import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class InjuryDialogStateService {
  private isDialogMinimizedSubject = new BehaviorSubject<boolean>(false);
  public isDialogMinimized$ = this.isDialogMinimizedSubject.asObservable();

  /**
   * Sets the minimization state of the injury dialog
   * @param isMinimized - true if the dialog is minimized, false if it's maximized or closed
   */
  setDialogMinimized(isMinimized: boolean): void {
    this.isDialogMinimizedSubject.next(isMinimized);
  }

  /**
   * Gets the current minimization state of the dialog
   */
  get isDialogMinimized(): boolean {
    return this.isDialogMinimizedSubject.value;
  }
}
